document.addEventListener('DOMContentLoaded', () => {
  const widget = document.getElementById('siteWidgetTogglerBtn');
  if (!widget || widget.dataset.logisyInitialized === 'true') return;
  
  widget.dataset.logisyInitialized = 'true';

  const pageType = window.shopifyPageType || 'page';
  let isDrawerOpen = false;
  let isFooterVisible = false;
  let isWidgetVisible = null;

  const updateVisibility = () => {
    if (['product', 'collection', 'search', '404', 'cart'].includes(pageType)) {
      widget.classList.toggle('hidden', true);
      widget.classList.toggle('opacity-0', true);
      widget.classList.toggle('invisible', true);
      widget.style.pointerEvents = 'none';
      return;
    }

    const shouldHide = isDrawerOpen || isFooterVisible;

    if (isWidgetVisible === !shouldHide) return;
    isWidgetVisible = !shouldHide;

    widget.classList.remove('hidden', 'opacity-0', 'invisible');

    if (!shouldHide) {
      widget.style.pointerEvents = 'auto';
      if (typeof Motion !== 'undefined') {
        Motion.animate(widget, { opacity: 1, visibility: 'visible', transform: ['translateY(15px)', 'translateY(0)'] }, { duration: 0.5, easing: [0.3, 1, 0.3, 1] });
      } else {
        widget.style.cssText = 'transition: all var(--animation-primary); opacity: 1; visibility: visible; transform: translateY(0); pointer-events: auto;';
      }
    } else {
      widget.style.pointerEvents = 'none';
      if (typeof Motion !== 'undefined') {
        Motion.animate(widget, { opacity: 0, visibility: 'hidden', transform: ['translateY(0)', 'translateY(15px)'] }, { duration: 0.5, easing: [0.3, 1, 0.3, 1] });
      } else {
        widget.style.cssText = 'transition: all var(--animation-primary); opacity: 0; visibility: hidden; transform: translateY(15px); pointer-events: none;';
      }
    }
  };

  updateVisibility();

  const bodyObserver = new MutationObserver(() => {
    const drawerState = document.body.classList.contains('has-modal-open') || 
                        document.body.classList.contains('has-modal-opening');
    
    if (isDrawerOpen !== drawerState) {
      isDrawerOpen = drawerState;
      updateVisibility();
    }
  });

  bodyObserver.observe(document.body, { 
    attributes: true, 
    attributeFilter: ['class'] 
  });

  const footer = document.querySelector('.footer, .footer-copyright');
  if (footer && typeof IntersectionObserver !== 'undefined') {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (isFooterVisible !== entry.isIntersecting) {
          isFooterVisible = entry.isIntersecting;
          updateVisibility();
        }
      });
    }, { rootMargin: '0px 0px 40px 0px' });
    observer.observe(footer);
  }

  if (pageType === 'product') {
    const mobileTriggerBtn = document.querySelector('.logisy-mobile-trigger');
    if (mobileTriggerBtn) {
      mobileTriggerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const widgetCheckbox = document.getElementById('siteWidgetModalChk');
        if (widgetCheckbox) widgetCheckbox.checked = true;
      });
    }
  }
});